import { Button } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../app/store";
import ConfirmDialog from "../../../../UI/ConfirmDialog";
import { deleteProject } from "../../../projectSlice";
import { useNavigate } from "react-router-dom";
import { projectsApi } from "../../../projectApi";

interface DeleteProps {
    projectId: number;
};

const ProjectViewDelete = (props: DeleteProps) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigateToLink = useNavigate();
  const { projectId } = props;

  const projectStatus = useSelector((state: RootState) => state.selectedProject.project.status);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);

    return (
      <>
      <div style={{ marginRight: "50%", marginTop: "10px" }}>
        <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
          {t("projectview_page.settings_page.deleteProjectHeader")}
        </div>
        <p>{t("projectview_page.settings_page.deleteProject.info")}</p>
        <Button 
            variant="contained" 
            size="small" 
            color="info"
            sx={{ marginTop: "15px" }}
            disabled={projectStatus === 5}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setDeleteDialogOpen(true);
            }}
        >
          {t("projectview_page.settings_page.deleteProjectHeader")}
        </Button>
      </div>
      <ConfirmDialog 
        key={"project-delete-confirm-dialog"}
        open={deleteDialogOpen}
        value={projectId}
        setOpen={setDeleteDialogOpen}
        onConfirm={ async () => {
          await dispatch(deleteProject(projectId));
          await dispatch(projectsApi.util.invalidateTags([{ type: "Projects", id: "USER_PROJECTS_LIST" }]));
          navigateToLink("/");
          }
        }
        content={t("projectview_page.settings_page.deleteProject.confirm_dialog")}
      />
      </>
    );
};

export default ProjectViewDelete;